import { VARIANT_ERROR } from '%app/js/common/components/material/Snackbar';
import Translator from '%app/js/common/services/translator';

function buildResponseErrorNotification(error) {
    let notification = {
        variant: VARIANT_ERROR,
        message: Translator.trans('seat_selection_integration.error_notification.reservation_failed'),
    };
    if (error.response && error.response.status < 500) {
        notification = { ...notification, message: Translator.trans(error.response.data.error_description) };
    }

    return notification;
}

export default buildResponseErrorNotification;
